import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

const bodyWrapperStyles = xcss({
	flexGrow: '1',
});

type SidePanelBodyProps = {
	children: React.ReactNode;
};

export const SidePanelBody = ({ children }: SidePanelBodyProps): React.JSX.Element => {
	return (
		<Box
			paddingBlock="space.100"
			paddingInlineStart="space.300"
			paddingInlineEnd="space.150"
			xcss={bodyWrapperStyles}
		>
			{children}
		</Box>
	);
};
